<template>
  <div class="wrapper"><br><br><br>
    <div class="container-fluid">
      <div class="row pt10 pb50" v-bind:class="{'pt30': $route.path === '/login'}">
        <div class="col-md-4 col-lg-2 hidden-xs"></div>
        <div class="col-xs-12 col-md-8 col-lg-8 border-box">
          <div class="row pb10">
            <div class="col-xs-12 col-md-12">
              <button
                v-if="$route.path === '/checkout'"
                v-on:click.prevent="previousStep"
                class="btn btn-xs pull-left mt25 mr20">&larr; Back</button>
              <h3 class="form-signin-heading" style="margin-top: 18px;">Reset your password</h3>
            </div>
          </div>
          <div class="row alert alert-danger" v-if="loginError">
            <div class="col-lg-12 col-xs-12 col-md-12" v-show="errorPassword">
              <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              <span class="sr-only">Error:</span>
              Password mismatch !
            </div>
          </div>
          <div class="row border-top p10 pb10">
            <div class="col-md-8 col-lg-8 col-xs-12 no-spacing border-right">
              <form class="form-signin" v-on:submit.prevent="resetPass">
                <label for="inputEmail" class="sr-only">Email address</label>
                <input v-model="credentials.email" type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
                <br><label for="inputPassword" class="sr-only">Password</label>
                <input v-model="credentials.password" type="password" id="inputPassword" class="form-control" placeholder="Password" required>
                <label for="inputPassword" class="sr-only">Password</label>
                <input v-model="credentials.passwordConfirm" type="password" id="inputPassword" class="form-control" placeholder="Confirm Password" required>
                  <vue-ladda :loading="loading" data-style="expand-right">
                    Submit
                  </vue-ladda>
              </form>
            </div>
            <div class="col-md-4 col-lg-4 col-xs-12 no-spacing center-content grey-box">
              <p class="pb10" style="text-align: left;">Don't have an account yet? Create a free account now to get started.</p>
              <button
                v-on:click.prevent="register"
                class="btn btn-sm btn-default btn-block">
                Create account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div></div> -->
</template>

<script>
'use strict'

import { HTTP } from '../../services/account-services'
import VueLadda from 'vue-ladda'
import {default as swal} from 'sweetalert2'
import { getQueryString } from '../../services/getParameter'
export default {
  name: 'ResetPassword',
  components: {
    'vue-ladda': VueLadda
  },
  data() {
    return {
      credentials: {},
      loginError: false,
      loading: false
    }
  },
  beforeMount() {
    let prevRoute = localStorage.getItem('previousRoute')
    if (prevRoute === '/login') {
      this.$router.push('/checkout')
    }
  },
  methods: {
    previousStep() {
      this.$parent.activeStep--
    },
    resetPass() {
      this.loading = true
      let token = getQueryString('token')
      console.log(token)
      if (this.credentials.password === this.credentials.passwordConfirm) {
        HTTP.post('/accounts/passwordReset',
          {
            email: this.credentials.email,
            password: this.credentials.password,
            token: token
          }
        ).then((result) => {
          console.log(result)
          this.loading = false
          swal(
            'Success !',
            'Your password has been reset !',
            'success'
          )
          this.$router.push('/login')
        }).catch((err) => {
          console.log(err)
          this.loading = false
          swal(
            'Hoops !',
            'Some thing is wrong :' + err,
            'error'
          )
        })
      }
    },
    register() {
      if (this.$route.path === '/checkout') {
        this.$parent.showSignupForm = true
      } else {
        this.$router.push('/signup')
      }
    }
  },
  props: [
    'loggedIn',
    // 'loading',
    'progress'
  ]
}
</script>
<style src="../Login/Login.css" scoped></style>



// WEBPACK FOOTER //
// src/components/ResetPassword/ResetPassword.vue